import styled from '@emotion/styled'
import { Input, NumberInputField, Select } from '@chakra-ui/react'

export const AddSessionFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

export const AdvancedFormWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 730px;
`

export const ContentBlockWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 5px 10px;
    margin: 16px 0;
    ${({ bordered }) =>
        bordered &&
        `
      border: 1px solid white;
      border-radius: 5px; 
  `}
`

export const UnderlineError = styled.div`
    font-size: 16px;
    color: #e53e3e;
`

export const FormContentBlockHeader = styled.div`
    line-height: 18px;
    font-size: 18px;
    ${({ half }) => (half ? 'margin: 0.25rem 0 0.5rem 0;' : 'margin: 1rem 1rem 0px 1rem;')}
    font-weight: 700;
`

export const FormContentBlockBody = styled.div`
    border: 1px solid var(--chakra-colors-form-section-border);
    border-radius: 5px;
    padding: ${({ half }) => (half ? '10px 16px' : '0')};
    background: var(--chakra-colors-form-section-background);
    height: 100%;
`
export const StyledInput = styled(Input)`
    border-radius: 5px;
    border-color: var(--chakra-colors-border);
    &:hover {
        border-color: var(--chakra-colors-border-hover);
    }
    background-color: var(--chakra-colors-input);
`

export const StyledNumberInputField = styled(NumberInputField)`
    border-radius: 5px;
    border-color: var(--chakra-colors-border);
    &:hover {
        border-color: var(--chakra-colors-border-hover);
    }
    background-color: var(--chakra-colors-input);
`   

export const StyledSelect = styled(Select)`
    border-color: var(--chakra-colors-border);
    &:hover {
        border-color: var(--chakra-colors-border-hover);
    }
    border-radius: 5px;
`

export const FormContentBlockWrapper = styled.div`
    position: relative;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
    opacity: ${({ disabled }) => (disabled ? '0.6' : '1')};
    margin: ${({ nested, half }) => (nested ? '0 15px 36px 15px' : half ? '0 0 0 0' : '0 0 20px 0')};
`
